module.exports = __webpack_public_path__ + "static/media/icon-group.7a70ec7f.svg";